import { createLabeledMessages } from '../../../messageUtils';
const generic = {
    genericErrorHeading: 'Došlo k neznámé chybě',
    fullErrorMessage: 'Úplný výpis chyby',
    copyError: 'Zkopírovat data pro HelpDesk',
    detailError: 'Zobrazit detail o chybě',
    copyAllErrors: 'Zkopírovat data o všech chybách',
    showFullError: 'Zobrazit úplný výpis chyby',
    hideFullError: 'Skrýt úplný výpis chyby',
    overviewOfErrors: 'Úplný přehled chyb',
    uniqueIdentifier: 'Jednoznačný identifikátor chyby',
    errorDescription: 'Popis chyby',
    closeError: 'Zavřít chybu',
    noVisibleErrors: 'Nejsou zde žádné viditelné chyby',
    sendError: 'Odeslat záznam o chybě na HD',
    sendAllErrors: 'Odeslat všechny chyby',
    errorSent: 'Hlášení o chybě úspěšně odesláno',
    errorNotSent: 'Neúspěšné odeslání',
    configJsonErrorHeading: 'chyba konfigurace',
    configJsonErrorDescription: 'došlo k chybě při načítání konfigurace aplikace',
    invalidRefreshLogoutHeading: 'Neplatný token',
    invalidRefreshLogoutDescription: 'Token pro obnovení již není možné použít. Pro opětovné přihlášení klikně na tlačítko "Odhlásit se".',
    brokenSessionLogoutHeading: 'Přerušená relace',
    brokenSessionLogoutDescription: 'Vaše relace je nevalidní. Pro opětovné přihlášení klikně na tlačítko "Odhlásit se".',
    genericLogoutHeading: 'Přihlášení se nezdařilo',
    genericLogoutDescription: 'Nastala chyba při pokusu o přihlášení. Pro opětovné přihlášení klikně na tlačítko "Odhlásit se".',
    loadCduErrorHeading: 'Nepodařilo se načíst uživatele z CDU',
    loadCduShortDescription: 'Prosím kontaktujte helpdesk a odhlašte se.',
    hideError: 'Skrýt chybu',
    hideAll: 'Skrýt vše',
    showAll: 'Ukázat vše',
    publicHeading: 'Online to nepůjde',
    publicCommonDescription: 'Opakujte prosím akci později nebo nás kontaktujte na telefonním čísle',
    publicKC: '241 114 114',
    notifierTitle: 'Seznam chyb'
};
const messages = Object.assign({}, generic);
export default Object.assign({}, messages, createLabeledMessages(messages));
